export default __webpack_public_path__ + "static/media/Portfolio.04af70bb.webp";